import {Directive, ViewContainerRef} from "@angular/core";

@Directive({selector: '[dxModalContentHost]'})
export class DxModalContentHostDirective {
  constructor(public viewRef: ViewContainerRef) { }
}
